import React, { createContext, useContext, useState } from "react";
import Modal from "../components/elements/Modal";
import { cn } from "../lib/utils";

const ModalContext = createContext();

export const DeleteModalProvider = ({ children, deleteHandler = () => {} }) => {
  const [modalContent, setModalContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const openModal = (content) => {
    setIsModalOpen(true);
    setModalContent(content);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null);
  };

  return (
    <ModalContext.Provider
      value={{
        isModalOpen,
        openModal,
        closeModal,
        setLoading,
        modalContent,
      }}
    >
      {children}
      <Modal isOpen={isModalOpen} onClose={closeModal} title={false} size="sm">
        <div className="flex items-center justify-center mb-3">
          <img
            src={require("../assets/images/delete.png")}
            alt="delete"
            className="w-12 h-12"
          />
        </div>
        <div className="text-center">
          You are trying to delete the record,
          <br /> click "Delete" below.
        </div>
        <div className="flex items-start justify-center gap-3 mt-4">
          <button
            type="button"
            onClick={closeModal}
            className="hover:opacity-80 border border-black text-black px-3 py-2 h-9 flex items-center justify-center gap-2 rounded-md"
          >
            <i className="fa-fw fa-regular fa-xmark"></i>
            <span>Cancel</span>
          </button>
          <button
            type="button"
            className="hover:opacity-80 border-transparent bg-destructive text-white px-3 py-2 h-9 flex items-center justify-center gap-2 rounded-md"
            onClick={deleteHandler}
          >
            <i
              className={cn(
                "fa-fw",
                loading
                  ? "fa-duotone fa-solid fa-spinner-third animate-spin"
                  : "fa-regular fa-trash-can"
              )}
            ></i>
            <span>Delete</span>
          </button>
        </div>
      </Modal>
    </ModalContext.Provider>
  );
};

export const useDelete = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error("useModal must be used within a ModalProvider");
  }
  return context;
};
